export default __webpack_public_path__ + "media/images/23-7bba0e5992d55ceb27cb42516778d078.jpg";